import { useState } from 'react'

import { useAppState } from '../../../context/appStateContext'
import useStrings from '../../../localization/useStrings'
import native from '../../../native/native'
import { formatCurrency } from '../../../utils/utils'

export interface FreeTrialPlan {
  name: string
  price: string
  timePeriodPrice: string
  timePeriodSubtitle: string
  selected: boolean
}

function useComparePlans() {
  const purchaseCurrent = () => {
    native.subscribe(current)
  }

  const { state } = useAppState()
  const strings = useStrings().freeTrialPaywall.comparePlans
  const [yearlySelected, setYearlySelected] = useState(true)

  const plan = state.productData!.premium

  const yearlyProduct = plan.yearlyProduct
  const monthlyProduct = plan.monthlyProduct

  const locale = yearlyProduct.priceLocale
  const yearlyPerMonthPrice = formatCurrency(yearlyProduct.price / 12, locale)
  const monthlyPerDayPrice = formatCurrency(monthlyProduct.price / 30, locale)

  const current = yearlySelected ? yearlyProduct : monthlyProduct

  const yearly: FreeTrialPlan = {
    name: strings.yearly,
    price: formatCurrency(yearlyProduct.price, locale),
    timePeriodPrice: strings.monthlyPrice(yearlyPerMonthPrice),
    timePeriodSubtitle: strings.freeFor(7),
    selected: yearlySelected,
  }

  const monthly: FreeTrialPlan = {
    name: strings.monthly,
    price: formatCurrency(monthlyProduct.price, locale),
    timePeriodPrice: strings.dailyPrice(monthlyPerDayPrice),
    timePeriodSubtitle: strings.freeFor(3),
    selected: !yearlySelected,
  }

  return { state: { yearly, monthly }, actions: { setYearlySelected, purchaseCurrent } }
}

export default useComparePlans
